import type { RouteObject } from "react-router"

export const domainsRoutes: RouteObject[] = [
  {
    path: "domains",
    lazy: () => import("./domains-page").then((m) => ({ Component: m.DomainsPage })),
  },
]
